module.exports = __webpack_public_path__ + "img/urban-movement.a733c7f3.png";